import React from 'react';
import { motion } from 'framer-motion';
export function AICapabilities() {
  return <section className="py-24 bg-stone-900 text-stone-50" data-id="element-756">
      <div className="max-w-6xl mx-auto px-6" data-id="element-757">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-758">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-759">
            {/* Left: Header */}
            <div className="lg:col-span-4" data-id="element-760">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-761">
                RateBrain Intelligence
              </p>

              <h2 className="font-serif text-4xl tracking-tight leading-[1.1] text-stone-50 mb-6" data-id="element-762">
                AI-powered pricing that protects your margins
              </h2>

              <p className="text-lg text-stone-400 leading-relaxed" data-id="element-763">
                RateBrain analyzes competitive pricing, demand patterns, and
                market intelligence to deliver optimal dynamic pricing for every
                group quote. Not a black box — transparent recommendations you
                can trust.
              </p>
            </div>

            {/* Right: Capabilities */}
            <div className="lg:col-span-8" data-id="element-764">
              <div className="border-t border-stone-700" data-id="element-765">
                <div className="py-6 border-b border-stone-700" data-id="element-766">
                  <div className="flex items-start gap-6" data-id="element-767">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-768">
                      01
                    </span>
                    <div data-id="element-769">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-770">
                        Dynamic Rate Optimization
                      </p>
                      <p className="text-stone-400" data-id="element-771">
                        Analyze real-time demand, seasonality, and competitive
                        set pricing to recommend optimal group rates. Maximize
                        RevPAR while staying competitive.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-700" data-id="element-772">
                  <div className="flex items-start gap-6" data-id="element-773">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-774">
                      02
                    </span>
                    <div data-id="element-775">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-776">
                        RFP Intelligence
                      </p>
                      <p className="text-stone-400" data-id="element-777">
                        Parse incoming RFPs from any format — email, PDF,
                        WhatsApp. Extract dates, rooms, budgets, and
                        requirements automatically in seconds.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-700" data-id="element-778">
                  <div className="flex items-start gap-6" data-id="element-779">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-780">
                      03
                    </span>
                    <div data-id="element-781">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-782">
                        Competitive Set Analysis
                      </p>
                      <p className="text-stone-400" data-id="element-783">
                        Monitor competitor pricing across your market. Know
                        exactly where you stand and when to adjust. Real-time
                        rate shopping intelligence.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-700" data-id="element-784">
                  <div className="flex items-start gap-6" data-id="element-785">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-786">
                      04
                    </span>
                    <div data-id="element-787">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-788">
                        Negotiation Copilot
                      </p>
                      <p className="text-stone-400" data-id="element-789">
                        AI-powered counter-offer suggestions that protect
                        margins while maximizing close probability. Enforce
                        pricing consistency across your team.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6" data-id="element-790">
                  <div className="flex items-start gap-6" data-id="element-791">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-792">
                      05
                    </span>
                    <div data-id="element-793">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-794">
                        Predictive Analytics
                      </p>
                      <p className="text-stone-400" data-id="element-795">
                        Close-probability scoring, demand forecasting, and price
                        elasticity modeling. Know which groups to prioritize and
                        when to flex on rate.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}